/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ConfigurationManagementOption {
    getFixupPrototypeFunction() { return ConfigurationManagementOption.fixupPrototype; }

    static newInstance(model: Partial<ConfigurationManagementOption>): ConfigurationManagementOption {
        let obj = Object.assign(new ConfigurationManagementOption(), model);
        ConfigurationManagementOption.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ConfigurationManagementOption>): ConfigurationManagementOption {
        if (!model) return null;
        return ConfigurationManagementOption.newInstance(<ConfigurationManagementOption> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ConfigurationManagementOption) {
        if (!obj) return;

        models.ConfigurationManagementOption.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ConfigurationManagementOption): boolean {
        Object.setPrototypeOf(obj, ConfigurationManagementOption.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Value identifier for the option
     */
    value: string;

}
